export default {
  categories: {
    id: 'menu_categories',
    defaultMessage: 'Categories',
  },
  see_all: {
    id: 'menu_see_all',
    defaultMessage: 'See all',
  },
  goodDeals: {
    id: 'menu_good_deals',
    defaultMessage: 'Good deals',
  },

  tradeInTitle_smartphones: {
    id: 'menu_trade-in_title_smartphones',
    defaultMessage: 'Trade-in',
  },
  tradeInDescription_smartphones: {
    id: 'menu_trade-in_description_smartphones',
    defaultMessage: 'Get up to $900 for your old device',
  },
  mobilePlanTitle_smartphones: {
    id: 'menu_mobile-plan_title_smartphones',
    defaultMessage: 'Exclusive deals',
  },
  mobilePlanDescription_smartphones: {
    id: 'menu_mobile-plan_description_smartphones',
    defaultMessage: 'Select a Visible+ plan at checkout and save',
  },
  tradeInTitle_laptops: {
    id: 'menu_trade-in_title_laptops',
    defaultMessage: 'Trade-in',
  },
  tradeInDescription_laptops: {
    id: 'menu_trade-in_description_laptops',
    defaultMessage: 'Get up to $900 for your old device',
  },
  goodToKnow: {
    id: 'good_to_know',
    defaultMessage: 'Good to know',
  },
}
